import BaseListPresenter from "../../../base/BaseListPresenter";
import saveAs from "../../../saveAs";

class EmployeeListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
  }

  onClickAdd() {
    const collection = this.view.getCollectionName();
    this.view.navigateTo("/admin/employee/form");
  }

  onClickEdit(empDetails) {
    this.view.navigateTo(`/admin/employees/form/${empDetails?.id}`);
  }

  async onClickUpdateStatus(empDetails) {
    const object = empDetails;
    const collection = this.view.getCollectionName();

    object.status =
      object?.status === "InActive"
        ? "Active"
        : empDetails.status === "Active"
        ? "InActive"
        : null;

    await this.upsertUseCase.execute(collection, object);
    this.view.setObjects(this.objects);
    this.reset();
    this.getObjects();
  }
}

export default EmployeeListPresenter;
